import { FC, useRef } from 'react';
import * as React from 'react';
import DocumentMeta from 'react-document-meta';
import * as ReactGA from 'react-ga';
import { useApi } from 'src/@context/Api';
import useReactRouter from 'use-react-router';
import Home from './Home';
import Page from './Page';
import Products from './Products';
import Product from './Product';
import News from './News';
import { makeStyles, createStyles } from '@material-ui/styles';
import { backgroundColor } from 'src/constants/stylesheet';
import Contact from './Contact';
import Download from './Download';
import Search from './Search';
import Footer from './Footer';

const useStyles = makeStyles(() =>
  createStyles({
    main: {
      flex: '1 1 auto',
    },
    footer: {
      flex: '0 0 auto',
      backgroundColor,
    },
  }));
export type PagesProps = {};
type Props = PagesProps;

const Pages: FC<Props> = () => {
  const cls = useStyles();
  const { location, location: { pathname } } = useReactRouter();
  const url = useRef(location.pathname);
  const { get, app } = useApi();
  const [page, setPage] = React.useState<IPageDto>();

  const scrollContainer = document.getElementById('scrollContainer');

  React.useEffect(() => {
    if (!scrollContainer) { return };

    if (scrollContainer.scrollTop > 0) {
      scrollContainer.scrollTop = 0
    }

  }, [page]);

  React.useEffect(() => {
    fetchPage();
  }, [pathname]);

  React.useEffect(
    () => {
      if (!app || !app.Config) { return; }
      const config = app.Config;

      if (!config.GoogleAnalyticsCode) { return; }

      ReactGA.initialize(`${config.GoogleAnalyticsCode}`);
      ReactGA.pageview(window.location.pathname);
    }, [page, app]);

  const fetchPage = async () => {
    const endpoint = location.pathname;
    url.current = endpoint;
    await get(endpoint)
      .then(pageDto => setPage(pageDto));
  }

  return (
    <>
      <main className={cls.main}>
        {app &&
          <DocumentMeta
            title={app.PageTitle || ''}
            description={app.PageDescription || ''}
          />
        }

        {page && page.type === "Home" &&
          <Home
            {...page as HomeDto}
          />
        }

        {page && page.type === "Page" &&
          <Page
            {...page as PageDto}
          />
        }

        {page && page.type === "Products" &&
          <Products
            {...page as ProductsDto}
          />
        }

        {page && page.type === "Product" &&
          <Product
            {...page as ProductDto}
          />
        }

        {page && page.type === "News" &&
          <News
            {...page as NewsDto}
          />
        }

        {page && page.type === "NewsInternal" &&
          <Page
            {...page as PageDto}
          />
        }

        {page && page.type === "LoosePage" &&
          <Page
            {...page as PageDto}
          />
        }

        {page && page.type === "Contact" &&
          <Contact
            {...page as ContactDto}
          />
        }

        {page && page.type === "Download" &&
          <Download
            {...page as DownloadDto}
          />
        }

        {page && page.type === "SearchPage" &&
          <Search
            {...page as SearchPageDto}
          />
        }
      </main>
      <footer className={cls.footer}>
        <Footer />
      </footer>
    </>
  );
};

export default Pages;



// WEBPACK FOOTER //
// ./src/Components/Pages.tsx